import React from 'react'
import { Header, Image, Message} from 'semantic-ui-react'
import styled from "styled-components";
import { Box, Flex } from 'rebass'

import { __ } from '~/i18n'
import cartFailure from '~/assets/img/cart-failure.svg'

import BlockingButton from '~/components/blocking-button'

const ErrorContainer = styled.div`
  padding-top: 50px;
`;

const HelpText = styled.div``;
const Buttons = styled.div`
  width: 270px;
  margin: 40px auto 20px;
  
  .ui.button {
    margin-bottom: 8px;
  }
`;

const AlignBox = styled(({ textAlign, ...rest }) => <Box {...rest} />)`
  text-align: ${props => (props.textAlign)}
`;

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    const { onError } = this.props;

    this.setState({ hasError: true });

    if(onError) {
      onError(error);
    }
  }

  render() {
    const { message } = this.props;
    if (this.state.hasError) {
      return (
        <Flex flexWrap='wrap' py={ 4 } justifyContent={ 'center' } mx={ -4 }>
          <AlignBox px={ 4 } width={ [ 1, 6/16 ] } textAlign='center'>
            <ErrorContainer>
              <Image src={ cartFailure } centered/>
              <Header>{ __('Something went wrong.') }</Header>
              <HelpText>
                { __('There was an error with the checkout process. Sometimes reloading the page will fix the problem. Would you like to try it now?') }
                { __('If the problem persists contact the store administrator.') }
              </HelpText>
              <Buttons>
                <BlockingButton fluid positive onClick={ () => {
                  if(typeof window !== 'undefined') {
                    window.location.reload();
                  }
                } } >{ __('Reload') }</BlockingButton>
              </Buttons>
            </ErrorContainer>
          </AlignBox>
        </Flex>
      );
    }
    return this.props.children;
  }
}
